import { render } from "./RadioGroupWrapper.vue?vue&type=template&id=6d428ef4"
import script from "./RadioGroupWrapper.vue?vue&type=script&lang=js"
export * from "./RadioGroupWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src910507242/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__